import { render, staticRenderFns } from "./VolunteerTeamOffer.vue?vue&type=template&id=dd95efea&scoped=true"
import script from "./VolunteerTeamOffer.vue?vue&type=script&lang=js"
export * from "./VolunteerTeamOffer.vue?vue&type=script&lang=js"
import style0 from "./VolunteerTeamOffer.vue?vue&type=style&index=0&id=dd95efea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd95efea",
  null
  
)

export default component.exports